import React from 'react';
import { Sentry } from '@guuru/sentry-web';
import ErrorPage from './500';

const ErrorBoundary = function ({
  children,
  fallback = ErrorPage,
  ...props
}: Sentry.ErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary {...props} fallback={fallback}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
